import React from "react";
import { connect } from "react-redux";
import { ContentHeader } from "./content-header";
import { Translation } from "../../../../core/translate";
import TrendingBook from "./trending-book";
import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import styled from "styled-components";
import {
  breakpointsPx,
  jsQueries,
  styledMedia
} from "../../../../components/mediaquery/breakpoints";
import Media from "react-media";
import { selectors as brandSelectors } from "../../../../../redux/brand";

const OuterContainer = styled.div`
  width: 100%;
  position: relative;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const TrendingBooksContainer = styled.ul`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 0 0;
  margin: 0;
  list-style-type: none;
  position: relative;

  @media (max-width: ${breakpointsPx.medium}) and (min-width: ${breakpointsPx.small}) {
    & > * {
      flex-basis: calc(50% - 20px);
    }
  }
`;

const ViewAllContainer = styled.div`
  display: none;
  margin-left: 10px;

  ${styledMedia.medium`
    display: block;
  `}

  ${styledMedia.small`
    transform: translateY(6px);
  `}
`;

const ViewAll = createThemedComponent(Button, {
  Button_paddingHorizontal_medium: 0
});

const TrendingContainer = ({
  topPopularTitleKey,
  showTopPopular,
  popular,
  onViewAll
}) => {
  if (!popular || popular.length === 0 || !showTopPopular) {
    return null;
  }

  function renderViewAll() {
    return (
      <ViewAll onClick={onViewAll} naked>
        <Translation id="explore.view-all">View All</Translation>
      </ViewAll>
    );
  }

  return (
    <OuterContainer>
      <ContentHeader>
        <HeaderContainer>
          <Translation id={topPopularTitleKey}>See what's trending</Translation>
          <ViewAllContainer>{renderViewAll()}</ViewAllContainer>
        </HeaderContainer>
      </ContentHeader>
      <TrendingBooksContainer>
        {popular.map(asset => (
          <TrendingBook key={asset.vbid} isbn={asset.vbid} />
        ))}
      </TrendingBooksContainer>
      <Media query={jsQueries.medium}>
        {matches => (matches ? null : renderViewAll())}
      </Media>
    </OuterContainer>
  );
};

const mapStateToProps = state => ({
  showTopPopular: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.showTopPopular",
    true
  ),
  topPopularTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.topPopularTitleKey"
  )
});

export default connect(mapStateToProps)(TrendingContainer);
